import axios from 'axios';
import { Order } from '../store/slices/ordersSlice';

const API_BASE = `${import.meta.env.VITE_API_BASE_URL ?? ''}/operations/orders`;

export const fetchUserOrders = async (tenantId: string, userId: string): Promise<Order[]> => {
  const url = `${API_BASE}/?buyer_id=${userId}`;
  const headers: Record<string, string> = {};
  if (tenantId) headers['X-Tenant-ID'] = tenantId;
  const response = await axios.get(url, { headers });
  return response.data;
}; 
